// src/components/avatar/seasons/seasonLive.js
//
// Keeps the admin's season changes (rewardSettings/seasons) live in this tab:
// one listener for the whole app, started by the first component that asks.
//
//   useSeasonLive();   // in any component that shows "on sale" — it
//                      // re-renders when the admin changes a season

import { useEffect, useState } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../../../firebase/firebaseConfig";
import { setSeasonOverrides } from "./seasonData";

const listeners = new Set();
let started = false;
let version = 0;

const start = () => {
  if (started) return;
  started = true;
  onSnapshot(
    doc(db, "rewardSettings", "seasons"),
    (snap) => {
      setSeasonOverrides((snap.exists() && snap.data().seasons) || {});
      version += 1;
      listeners.forEach((f) => f(version));
    },
    () => {
      started = false; // not signed in yet — try again next time
    }
  );
};

export const useSeasonLive = () => {
  const [v, setV] = useState(version);
  useEffect(() => {
    start();
    listeners.add(setV);
    return () => listeners.delete(setV);
  }, []);
  return v;
};
